import React from 'react';

import { LinearProgress } from '@mui/material';

import * as Models from 'contracts/models';

import useStyles from './styles';

interface Props {
    license: Models.UserInfo.License;
    className?: string;
}

const LicenseCreditBar: React.FC<Props> = ({ license, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.info}>
                <span className={classes.title}>{'Credits'}</span>
                <span className={classes.amount}>
                    {license.amount}&nbsp;{'/'}&nbsp;{license.capacity}
                </span>
            </div>
            <LinearProgress
                variant="determinate"
                className={classes.progress}
                value={(license.amount / license.capacity) * 100}
            />
        </div>
    );
};

export default LicenseCreditBar;
